import { render, staticRenderFns } from "./myReview.vue?vue&type=template&id=61fba499&scoped=true&"
import script from "./myReview.vue?vue&type=script&lang=js&"
export * from "./myReview.vue?vue&type=script&lang=js&"
import style0 from "./myReview.vue?vue&type=style&index=0&id=61fba499&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fba499",
  null
  
)

export default component.exports